import * as _ from 'underscore';
import { Module } from '../Module';
import { GetExtractEncryptionStatsRequest, IGetExtractEncryptionStatsResult } from '../ServerApi/requests/GetExtractEncryptionStatsRequest';
import { IPoller, PollService } from './PollService';

export class ExtractEncryptionService {

  private extractEncryptionStatusInterval = 10000; // Polling interval of 10 secs
  private statusPoller: IPoller<IGetExtractEncryptionStatsResult>;

  public static $inject = [
    'PollService'
  ];

  constructor(
    private pollService: PollService
  ) {}

  public pollExtractEncryptionStats(siteId: string): ng.IPromise<any> {
    const isComplete = (result: IGetExtractEncryptionStatsResult): boolean => {
      return result && result.counts && result.counts.encrypting === 0 && result.counts.decrypting === 0;
    };

    this.statusPoller = this.pollService.poll(new GetExtractEncryptionStatsRequest({id: siteId}), isComplete, this.extractEncryptionStatusInterval);
    return this.statusPoller.promise;
  }

  public cancelExtractEncryptionStatsPolling() {
    if(!_.isUndefined(this.statusPoller)) {
      this.statusPoller.cancel();
    }
  }
}

Module.instance().service('ExtractEncryptionService', ExtractEncryptionService);
